import { createJsonNormalizer, createShapeNormalizer } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_PROMOTION_TRANSACTION_FEE_UPSELL = createFcmConfig('promotion_transaction_fee_upsell', {
	normalizer: createJsonNormalizer(
		createShapeNormalizer({
			type: 'object',
			shape: {
				experiment_name: { type: 'string' },
			},
		}),
	),
	defaultValue: undefined,
});
